import axios from "axios";
import * as d3 from "d3";
import {
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(res => {
        let data = res.data;

        var product_categories = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            .entries(data);

        var county_categories = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            .entries(data);

        // var radius = d3.scaleSqrt()
        //     .domain([0, d3.max(data, function (d) {
        //         return d.metric4;
        //     })])
        //     .range([2, 5]);

        let numRows = county_categories.length;
        let numCols = product_categories.length;

        let size = chart.width / numCols;

        for (let i = 0; i < numRows; i++) {
            // Add title for the entire row
            console.log("hello",county_categories[i]);
            var name = county_categories[i].key
            svg.append('text')
                .attr('x', chart.margin.left - 150)
                .attr('y', i * size + chart.margin.top-110)
                .style('text-anchor', 'middle')
                .style('font-size', '16px')
                .style('font-weight', 'bold')
                .style('fill','blue')
                .text(name);
            for (let j = 0; j < numCols; j++) {
               // let currentData = data.filter(d => d.dim1_name === county_categories[i].key && d.dim2_name === product_categories[j].key);

                let x1AxisLabel=data.map(function (d){
                    return d.dim3_name;
                })
                let y1AxisLabel=data.map(function (d){
                    return d.dim4_name;
                })

                let x1Scale = d3.scaleBand().domain(x1AxisLabel).range([0, size - 2 * 40]);
                let y1Scale = d3.scaleBand().domain(y1AxisLabel).range([size - 2 * 40, 0]);

                var tmp = svg.append('g')
                    .attr('transform', 'translate(' + (j * size) + ',' + (i * size) + ')'); // Adjust translation based on row and column

                // tmp.append('text')
                //     .attr('x', size / 2 - 40) // Adjust the x position based on the chart size
                //     .attr('y', -20) // Adjust the y position based on the chart size
                //     .style('text-anchor', 'middle')
                //     .style('font-size', '16px') // Adjust font size as needed
                //     .style('font-weight', 'bold') // Adjust font weight as needed
                //     .text('Chart Title for Row ' + i + ', Column ' + j);

                tmp.append('text')
                    .attr('x', size / 2 - 40) // Adjust the x position based on the chart size
                    .attr('y', size ) // Adjust the y position based on the chart size
                    .style('text-anchor', 'middle')
                    .style('font-size', axisLabelFontSize)
                    .text('Sub categories');

                tmp.append('g')
                    .attr('transform', 'translate(' + 0 + ',' + (size - 40 * 2) + ')')
                    .call(d3.axisBottom(x1Scale)).style('font-size', axisLabelFontSize)
                    .selectAll('text')
                    .style('text-anchor', 'end')
                    .attr('dx', '-.0em')
                    .attr('transform', 'rotate(-35)');

                // Y-axis Title
                tmp.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', -65) // Adjust the y position based on the chart size
                    .attr('x', -size / 2 + 40) // Adjust the x position based on the chart size
                    .style('text-anchor', 'middle')
                    .style('font-size', axisLabelFontSize)
                    .text('Brand');

                tmp.append('g').call(d3.axisLeft(y1Scale)).style('font-size', axisLabelFontSize);

                    // .on('mouseover', y1tip.show)
                    // .on('mouseout', y1tip.hide)
                    // .on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
                }
            }
    })
}
